export default function NoMicromanagement() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Лидерство без микроменеджмента
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Почему постоянный контроль не делает руководителя сильнее
        </p>

        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-xl border border-red-200 p-6 md:p-8">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-close-circle-line text-red-600 text-lg"></i>
              </div>
              <h3 className="font-bold text-gray-900 text-base">Цепочка микроменеджмента</h3>
            </div>
            <div className="space-y-3">
              {[
                'Руководитель не доверяет сотруднику',
                'Начинает контролировать каждый шаг',
                'Сотрудник перестаёт принимать решения',
                'Руководитель получает ещё больше нагрузки',
                'Команда становится ещё менее самостоятельной',
              ].map((step, i) => (
                <div key={i} className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-red-100 text-red-600 text-xs font-bold flex items-center justify-center flex-shrink-0">{i + 1}</span>
                  <span className="text-sm text-gray-700">{step}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-xl border border-teal-200 p-6 md:p-8">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-checkbox-circle-line text-teal-600 text-lg"></i>
              </div>
              <h3 className="font-bold text-gray-900 text-base">Альтернатива: система самостоятельности</h3>
            </div>
            <div className="space-y-3">
              {[
                'Понятная задача',
                'Критерии результата',
                'Зона ответственности',
                'Контрольные точки',
                'Обратная связь',
                'Самостоятельность',
              ].map((step, i) => (
                <div key={i} className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-teal-100 text-teal-700 text-xs font-bold flex items-center justify-center flex-shrink-0">{i + 1}</span>
                  <span className="text-sm text-gray-700">{step}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 p-6 md:p-8 max-w-4xl mx-auto">
          <p className="text-base text-gray-700 leading-relaxed mb-4">
            Задача лидера — не контролировать каждое действие сотрудника, а создать систему, в которой человек понимает:
          </p>
          <div className="grid sm:grid-cols-2 gap-3">
            {[
              'что необходимо сделать;',
              'зачем это необходимо;',
              'какой результат ожидается;',
              'какие у него полномочия;',
              'когда необходимо синхронизироваться;',
              'за что он отвечает лично.',
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-2 text-sm text-gray-600">
                <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}